// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import AffiliateLinkController from "./affiliate_link_controller"
application.register("affiliate-link", AffiliateLinkController)

import AffiliateTrackingController from "./affiliate_tracking_controller"
application.register("affiliate-tracking", AffiliateTrackingController)

import AreaSelectController from "./area_select_controller"
application.register("area-select", AreaSelectController)

import AutocompleteController from "./autocomplete_controller"
application.register("autocomplete", AutocompleteController)

import ConfirmationController from "./confirmation_controller"
application.register("confirmation", ConfirmationController)

import CookieClearController from "./cookie_clear_controller"
application.register("cookie-clear", CookieClearController)

import Coupon__Editor__FormController from "./coupon/editor/form_controller"
application.register("coupon--editor--form", Coupon__Editor__FormController)

import Coupon__Editor__ToggleController from "./coupon/editor/toggle_controller"
application.register("coupon--editor--toggle", Coupon__Editor__ToggleController)

import Coupon__EditorController from "./coupon/editor_controller"
application.register("coupon--editor", Coupon__EditorController)

import Coupon__FavoriteButtonController from "./coupon/favorite_button_controller"
application.register("coupon--favorite-button", Coupon__FavoriteButtonController)

import Coupon__HideButtonController from "./coupon/hide_button_controller"
application.register("coupon--hide-button", Coupon__HideButtonController)

import Coupon__MenuController from "./coupon/menu_controller"
application.register("coupon--menu", Coupon__MenuController)

import Coupon__SimilarCouponsController from "./coupon/similar_coupons_controller"
application.register("coupon--similar-coupons", Coupon__SimilarCouponsController)

import CouponGroupController from "./coupon_group_controller"
application.register("coupon-group", CouponGroupController)

import DialogController from "./dialog_controller"
application.register("dialog", DialogController)

import FeedbackController from "./feedback_controller"
application.register("feedback", FeedbackController)

import HeaderSearch__ErrorMessageController from "./header_search/error_message_controller"
application.register("header-search--error-message", HeaderSearch__ErrorMessageController)

import HeaderSearch__ErrorSearchFieldController from "./header_search/error_search_field_controller"
application.register("header-search--error-search-field", HeaderSearch__ErrorSearchFieldController)

import HeaderSearchController from "./header_search_controller"
application.register("header-search", HeaderSearchController)

import HoverController from "./hover_controller"
application.register("hover", HoverController)

import MainFilter__DialogController from "./main_filter/dialog_controller"
application.register("main-filter--dialog", MainFilter__DialogController)

import ScreenController from "./screen_controller"
application.register("screen", ScreenController)

import ScrollToTopController from "./scroll_to_top_controller"
application.register("scroll-to-top", ScrollToTopController)

import SearchFieldController from "./search_field_controller"
application.register("search-field", SearchFieldController)

import SiteLinks__MenuController from "./site_links/menu_controller"
application.register("site-links--menu", SiteLinks__MenuController)

import SiteLinksController from "./site_links_controller"
application.register("site-links", SiteLinksController)

import SubFilter__MobileDialogController from "./sub_filter/mobile_dialog_controller"
application.register("sub-filter--mobile-dialog", SubFilter__MobileDialogController)

import SubFilterController from "./sub_filter_controller"
application.register("sub-filter", SubFilterController)
